import script from "./ContactUsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactUsView.vue?vue&type=script&setup=true&lang=js"

import "./ContactUsView.vue?vue&type=style&index=0&id=4a34515a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a34515a"]])

export default __exports__